module.exports = __webpack_public_path__ + "img/Katie.c20b9fe7.jpg";